// Small pure helpers behind the staff home dashboard charts and feeds.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Calendar months ending with the current one, oldest first:
// [{ label: 'May', start: ISO, end: ISO }, ...]
export const monthRanges = (count, now = new Date()) => Array.from({ length: count }, (_, i) => {
  const first = new Date(now.getFullYear(), now.getMonth() - (count - 1 - i), 1);
  const last = new Date(first.getFullYear(), first.getMonth() + 1, 0, 23, 59, 59);
  return {
    label: MONTHS[first.getMonth()],
    start: first.toISOString(),
    end: last.toISOString()
  };
});

// Heights as whole percentages of the tallest value (at least `floor` when
// there is any value, so a small bar is still visible). All zero -> all 0.
export const scaleBars = (values, floor = 4) => {
  const max = Math.max(0, ...values.map((v) => Number(v) || 0));
  if (max === 0) return values.map(() => 0);
  return values.map((v) => {
    const n = Number(v) || 0;
    return n <= 0 ? 0 : Math.max(floor, Math.round((n / max) * 100));
  });
};

export const relativeTime = (value, now = new Date()) => {
  const then = new Date(value);
  if (Number.isNaN(then.getTime())) return '';
  const minutes = Math.round((now.getTime() - then.getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return then.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};

export const greetingFor = (hour) => {
  if (hour < 5) return 'Hello';
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

// The things worth a look right now, most urgent first, from the ticket stats
// plus the counts the home page already loads.
export const attentionItems = ({ stats, leads = 0, domains = 0 }) => {
  const items = [];
  const s = stats || {};
  if (s.breachingCount > 0) items.push({ key: 'breach', tone: 'bad', icon: 'fa-triangle-exclamation', text: `${s.breachingCount} ticket${s.breachingCount === 1 ? '' : 's'} past their due date`, path: '/tickets?status=open' });
  if (s.unassignedOpenCount > 0) items.push({ key: 'unassigned', tone: 'warn', icon: 'fa-user-slash', text: `${s.unassignedOpenCount} open ticket${s.unassignedOpenCount === 1 ? '' : 's'} with no owner`, path: '/tickets?status=open' });
  if (s.dueTodayCount > 0) items.push({ key: 'today', tone: 'warn', icon: 'fa-clock', text: `${s.dueTodayCount} ticket${s.dueTodayCount === 1 ? '' : 's'} due today`, path: '/tickets?status=open' });
  if (leads > 0) items.push({ key: 'leads', tone: 'warn', icon: 'fa-bullseye', text: `${leads} lead${leads === 1 ? '' : 's'} to follow up`, path: '/leads' });
  if (domains > 0) items.push({ key: 'domains', tone: 'info', icon: 'fa-globe', text: `${domains} domain${domains === 1 ? '' : 's'} expiring within 30 days`, path: null });
  return items;
};
